import configs from '@/config'
import Vue from 'vue'

const actions = {
  getFeatureSettings: {
    method: 'GET',
    url: `${configs.baseUrl}/api/feature-settings`,
  },
}

let resource

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getFeatureSettings = async () => {
  if (!resource) initResource()
  const res = await resource.getFeatureSettings()
  return res.body
}

export default {
  initResource,
  getFeatureSettings,
}
